const ProfileIcon = ({ size = 20, color = 'currentColor', ...props }) => {
    return (
        <svg width={size} height={size} viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
            <path
                d="M10 17.5C14.1421 17.5 17.5 14.1421 17.5 10C17.5 5.85786 14.1421 2.5 10 2.5C5.85786 2.5 2.5 5.85786 2.5 10C2.5 14.1421 5.85786 17.5 10 17.5Z"
                stroke={color}
                strokeWidth="1.25"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <mask id="path-2-inside-1_8408_78924" fill="white">
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M5.48039 12.9418C5.16018 12.6181 5.16018 12.1028 5.48039 11.7791C6.62393 10.6231 8.21112 9.90698 9.96557 9.90698C11.72 9.90698 13.3072 10.6231 14.4507 11.7791C14.771 12.1028 14.771 12.6181 14.4507 12.9418C13.3072 14.0977 11.72 14.8139 9.96557 14.8139C8.21112 14.8139 6.62393 14.0977 5.48039 12.9418Z"
                />
            </mask>
            <path
                d="M14.4507 11.7791L13.5621 12.6582L14.4507 11.7791ZM14.4507 12.9418L13.5621 12.0627L14.4507 12.9418ZM5.48039 11.7791L6.36903 12.6582C7.28741 11.7298 8.55843 11.157 9.96557 11.157V9.90698V8.65698C7.8638 8.65698 5.96045 9.51644 4.59176 10.9L5.48039 11.7791ZM9.96557 9.90698V11.157C11.3727 11.157 12.6437 11.7298 13.5621 12.6582L14.4507 11.7791L15.3394 10.9C13.9707 9.51644 12.0673 8.65698 9.96557 8.65698V9.90698ZM14.4507 12.9418L13.5621 12.0627C12.6437 12.991 11.3727 13.5639 9.96557 13.5639V14.8139V16.0639C12.0673 16.0639 13.9707 15.2044 15.3394 13.8209L14.4507 12.9418ZM9.96557 14.8139V13.5639C8.55843 13.5639 7.28741 12.991 6.36903 12.0627L5.48039 12.9418L4.59176 13.8209C5.96045 15.2044 7.8638 16.0639 9.96557 16.0639V14.8139ZM14.4507 11.7791L13.5621 12.6582C13.4005 12.4948 13.4005 12.226 13.5621 12.0627L14.4507 12.9418L15.3394 13.8209C16.1414 13.0102 16.1414 11.7107 15.3394 10.9L14.4507 11.7791ZM5.48039 11.7791L4.59176 10.9C3.78973 11.7107 3.78973 13.0102 4.59176 13.8209L5.48039 12.9418L6.36903 12.0627C6.53064 12.226 6.53064 12.4948 6.36903 12.6582L5.48039 11.7791Z"
                fill={color}
                mask="url(#path-2-inside-1_8408_78924)"
            />
            <circle
                cx="9.96556"
                cy="7.80394"
                r="2.17894"
                stroke={color}
                strokeWidth="1.25"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
        </svg>
    )
}

export default ProfileIcon
